import { useState, useEffect, useCallback } from "react";
import Paper from 'apollo-react/components/Paper';
import Typography from 'apollo-react/components/Typography';
import Box from 'apollo-react/components/Box';

import DataTableComponent from "../DataTable/PrimeDataTable";

import axiosInstance from "../../../axiosInstance";
import { useFileDownload } from "../../../hooks/useFileDownload";

const AuditTrails = ({ requestID, persona, role }) => {
    const [loading, setLoading] = useState(false);

    const { downloadFile } = useFileDownload(persona);

    const [data, setData] = useState([]);

    const fetchAuditTrails = useCallback(async () => {
        try {
            if(!requestID) {
                return;
            }
            setLoading(true);
            const link = `/api/v1/request-audit-trails/${persona === "customer" ? "enduser" : ""}/request/${requestID}`;
            const response = await axiosInstance.get(link);
            console.log("response.data.data", response.data.data);
            setData(response.data.data);
        } catch (error) {
            console.error("Error fetching audit trails:", error);
        } finally {
            setLoading(false);
        }
    }, [requestID, persona]);

    useEffect(() => {
        fetchAuditTrails();
    }, [fetchAuditTrails]);

    const columns = [
        { field: "actor.username", header: "Username", sortable: true },
        { field: "actor.email", header: "Email", sortable: true},
        {
            field: "action", header: "Action", sortable: true, filter: true, body: (rowData) => {
                if (rowData?.action?.toLowerCase()?.includes("sent to assessment reviewer"))
                    return rowData.action;
                return rowData.action.replace(/assessment reviewer/gi, '').trim()
            }
        },
        { field: "entity.comment", header: "Comment", sortable: true, filter: true },
        { field: "createdAt", header: "Created at", sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
      ];
    
      const actions = [
        { text: "Download Attachment",
            color: "primary", onClick: async(row) => {
            if(row.file) {
                try {
                    await downloadFile(row.file.id, row.file.original_name);
                } catch (error) {
                    console.error("Error downloading file:", error);
                }
            }
        }},
      ];

      if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <Typography>Loading...</Typography>
        </Box>
    }

    if (data.length === 0) {
        return <Paper elevation={1} sx={{display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 300}}>
            <Typography>No audit trails found</Typography>
        </Paper>;
    }

    return (
        <div>
            <DataTableComponent
                data={data}
                columns={columns}
                actions={actions}
                enablePagination={true}
                enableLazyLoading={false}
            />
        </div>
    )
}

export default AuditTrails;